import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useError } from '../contexts/ErrorContext';

/**
 * Shows a session-expired notice and redirects to login when the JWT is rejected (401).
 */
export const useJwtExpiration = () => {
  const { wasAutoLoggedOut, clearAutoLogoutFlag } = useAuth();
  const { showWarning } = useError();
  const navigate = useNavigate();

  useEffect(() => {
    if (wasAutoLoggedOut) {
      showWarning('Your session has expired. Please log in again.');
      clearAutoLogoutFlag();

      const redirectTimer = window.setTimeout(() => {
        navigate('/login', { replace: true });
      }, 2000);

      return () => window.clearTimeout(redirectTimer);
    }
  }, [wasAutoLoggedOut, clearAutoLogoutFlag, showWarning, navigate]);

  return {
    wasAutoLoggedOut,
    clearAutoLogoutFlag,
  };
};
